<template>
<div class="overview-contacts">

  <vue-headful
    title="TZ Design Box - Overview Contacts"
    description="TZ Design Box"
/>

  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'overview-contacts'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
        <Breadcrumbs/>
        <hr>
        <div class="content">
          <h2>{{ $t("overview-contacts") }}</h2>
          <p>{{ $t("contacts-overview-details") }}</p>
          <table class="table">
          <thead>
            <tr>
                <th>{{ $t("name") }}</th>
                <th>{{ $t("email") }}</th>
                <th>{{ $t("dealer-admin") }}</th>
                <th>{{ $t("active") }}</th>
                <th>{{ $t("edit") }}</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="contact in getContacts" :key="contact.id">
                    <td>{{contact.name}}</td>
                    <td>{{contact.email}}</td>
                    <td>{{contact.dealer_admin}}</td>
                    <td>{{contact.active}}</td>
                    <td>
                      <a class="button">
                        <router-link :to="{name : 'contact-edit', params: {coid : contact.id}}"
                        >{{ $t("edit") }}
                        </router-link>
                      </a>
                    </td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MenuVert         from '@/components/MenuVert'
import Breadcrumbs      from '@/components/Breadcrumbs'
import { mapGetters }   from 'vuex'

export default {
    name:'OverviewContacts',
    computed: {...mapGetters([
        "getCurrentCompany", "getContacts", "getCompany"])
    },
    data: function(){
        return{
        }
    },
    components: { MenuVert,Breadcrumbs},
    created () {
        var self = this
        this.$store.dispatch ("callContacts",{self: self,company: this.getCompany})
    }
}
</script>

<style>
.overview-contacts{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
</style>
